import { Scenario, Session, Step, ExaminationDecision } from "@/models";
import { Model } from "pinia-orm";

export default class Examination extends Model {
  static entity = "examinations";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      name: this.string(""),
      code: this.string(""),
      isRepechage: this.boolean(false),
      order: this.attr(null),
      duration: this.attr(0),
      minimumRequired: this.number(null),
      minimumRequiredByCompetence: this.number(null),
      examinationType: this.string(""),
      userSessionVisible: this.boolean(true),
      hasCustomDate: this.boolean(false),
      examDecisionRequired: this.boolean(null),
      superadminExamDecisionRequired: this.boolean(null),
      adminExamDecisionRequired: this.boolean(null),
      ratingGridDocumentUuid: this.string(""),
      instructionDocumentUuid: this.string(""),
      examinationSpecification: this.string(""),
      hasDeviationLevel: this.boolean(false),

      // Foreign keys
      parentUuid: this.string(""),
      stepUuid: this.string(""),
      nextExaminationsSuccess: this.attr([]),
      nextExaminationsFailure: this.attr([]),
      stepData: this.belongsTo(Step, "stepUuid"),
      scenarios: this.hasMany(Scenario, "examinationUuid"),
      examinationDecisions: this.hasMany(ExaminationDecision, "examinationUuid"),
      sessions: this.hasMany(Session, "examinationUuid"),
      isDisplayed: this.boolean(true),
      // INFO - AG 31/05/23 - This two fields are send by a custom serializer ExaminationWithDomainProtoSerializer
      // which allows linked fields to be returned across several models without fetching intermediate models.
      // Do not remove
      domainUuid: this.string(""),
      cycleType: this.string(""),
    };
  }

  get isAutoDecision() {
    return (
      !this.examDecisionRequired &&
      !this.adminExamDecisionRequired &&
      !this.superadminExamDecisionRequired
    );
  }

  get getDomain() {
    return this.stepData.cycleData.domainVersionData.domainData;
  }
}
